module.exports = {
    IDLE: 'IDLE',
    FETCHING_CONFIG: 'FETCHING_CONFIG',
    CONFIG_FETCHED_SUCCESSFULLY: 'CONFIG_FETCHED_SUCCESSFULLY',
    CONFIG_FETCH_ERROR: 'CONFIG_FETCH_ERROR'
}
